// extracted by mini-css-extract-plugin
export default {"app":"App_app__GUp75","buffer":"App_buffer__yG19w"};